import { Option } from '@sapphire/result';
import type { Nullable } from '@ps/utils';

import {
  PROJECT_SHARED_METADATA_FIELDS,
  type PatchableMetaData,
  type SurveyMetadataForm,
} from '../../models/survey-metadata.model';

export function changedSharedMetadata(
  previous: Nullable<SurveyMetadataForm>,
  next: Nullable<SurveyMetadataForm>,
): PatchableMetaData {
  return Option.from(previous)
    .andThen((prev) =>
      Option.from(next).map((nextValue) => [prev, nextValue] as const),
    )
    .mapOr({}, ([prev, nextValue]) =>
      PROJECT_SHARED_METADATA_FIELDS.reduce<PatchableMetaData>(
        (changes, field) =>
          prev[field] === nextValue[field]
            ? changes
            : { ...changes, [field]: nextValue[field] },
        {},
      ),
    );
}

export function hasSharedMetadata(changes: PatchableMetaData): boolean {
  return !!Object.keys(changes).length;
}
